// @flow

import PropTypes from 'prop-types';

export const ModalTypes = {
  login: 'login',
  loginMfa: 'loginMfa',
  signup: 'signup',
  personalizedLogin: 'personalizedLogin',
  socialSignupWithAge: 'socialSignupWithAge',
  FBEmailRerequest: 'FBEmailRerequest',
  FBEmailCollection: 'FBEmailCollection',
  emailConfirmation: 'emailConfirmation',
  magicLinkConfirmation: 'magicLinkConfirmation',
  FBEmailAlreadyExist: 'FBEmailAlreadyExist',
};
export type ModalTypesFlowType = $Values<typeof ModalTypes>;

export const SignupTypes = {
  login: 'login',
  loginMfa: 'loginMfa',
  signup: 'signup',
  signupOrPersonalizedLogin: 'signupOrPersonalizedLogin',
  socialSignupWithAge: 'socialSignupWithAge',
  FBEmailRerequest: 'FBEmailRerequest',
  emailConfirmation: 'emailConfirmation',
  magicLinkConfirmation: 'magicLinkConfirmation',
  FBEmailAlreadyExist: 'FBEmailAlreadyExist',
  FBEmailCollection: 'FBEmailCollection',
  respondMessage: 'respondMessage',
};

export type SignupTypesFlowType = $Values<typeof SignupTypes>;

export const SignupSource = {
  boardPage: 'boardPage',
  boardInvite: 'boardInvite',
  defaultSource: 'defaultSource',
  homePage: 'homePage',
  mwebDefaultSource: 'mwebDefaultSource',
  invite: 'invite',
  login: 'login',
  userFollow: 'userFollow',
  userProfilePage: 'userProfilePage',
  saveButton: 'saveButton',
  actionButton: 'actionButton',

  // Only used by UnauthPinPage as part of unauth_pinclick_education experimentGroup
  // Other pages ties the signupButton to defaultSource. TODO unify all pages if we ship
  signupButton: 'signupButton',

  personalizedFlyout: 'personalizedFlyout',
  navigateBoard: 'navigateBoard',
  navigatePin: 'navigatePin',
  navigateInterest: 'navigateInterest',
  unauthHeader: 'unauthHeader',
  unauthBanner: 'unauthBanner',
  giftWrap: 'giftWrap',
  loginMfa: 'loginMfa',
};

export type SignupSourceType = $Values<typeof SignupSource>;

export const SignupSourcePropType = PropTypes.oneOf([
  SignupSource.boardPage,
  SignupSource.boardInvite,
  SignupSource.defaultSource,
  SignupSource.giftWrap,
  SignupSource.homePage,
  SignupSource.invite,
  SignupSource.login,
  SignupSource.mwebDefaultSource,
  SignupSource.navigateBoard,
  SignupSource.navigatePin,
  SignupSource.navigateInterest,
  SignupSource.saveButton,
  SignupSource.signupButton,
  SignupSource.unauthBanner,
  SignupSource.unauthHeader,
  SignupSource.userFollow,
  SignupSource.userProfilePage,
]);
